import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Badge } from "../../ui/badge";
import { Button } from "../../ui/button";

export const GroupFormerMembersDialog = ({
  open,
  onOpenChange,
  selectedGroupForMembers,
  clients,
  onReactivate
}) => {
  // Get former members (non-active status)
  const formerMembers = selectedGroupForMembers?.members?.filter(m => m.status !== 'active') || [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Former Members - {selectedGroupForMembers?.name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 max-h-[500px] overflow-y-auto">
          {formerMembers.map(member => {
            const client = clients.find(c => c.id === member.client_id);
            return (
              <div key={member.client_id} className="p-4 bg-gray-50 rounded border">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <p className="font-medium">{client?.full_name || member.client_details?.full_name || member.client_name || 'Unknown Client'}</p>
                    <div className="text-sm text-gray-600 mt-1 space-y-1">
                      <p>Joined: {new Date(member.joined_date).toLocaleDateString()}</p>
                      {member.exit_date && (
                        <p>Left: {new Date(member.exit_date).toLocaleDateString()}</p>
                      )}
                      <p>Sessions Attended: {member.sessions_attended}/{member.total_sessions || 'N/A'}</p>
                      {member.exit_reason && (
                        <p className="font-medium">
                          Reason: <span className="capitalize">{member.exit_reason.replace(/_/g, ' ')}</span>
                        </p>
                      )}
                      {member.exit_notes && (
                        <p className="text-xs bg-white p-2 rounded mt-1">
                          Notes: {member.exit_notes}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-2">
                    <Badge variant="outline" className="capitalize">
                      {member.status}
                    </Badge>
                    {onReactivate && (
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => onReactivate(member.client_id)}
                        className="text-xs h-7"
                        data-testid={`reactivate-member-${member.client_id}`}
                      >
                        ↩ Reactivate
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
          {formerMembers.length === 0 && (
            <p className="text-gray-500 text-center py-4">No former members</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GroupFormerMembersDialog;
